// extracted by mini-css-extract-plugin
export default {"Spinner":"SpinnerButton_Spinner__kMI7B","spin":"SpinnerButton_spin__PhQp3"};